import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  introduce: {
    title: ['四维看看 Pro', '专业精准建模，高效复刻空间'],
    price: 'RMB 9,800',
    dec: '高精度3D空间相机，12K高清分辨率，支持4倍细节放大，720°空间漫游。',
    btn: '立即购买',
    subTitle: '让三维空间获得数字新生',
    benefitGroup: [

      {
        fontImg: 'icon-qiumu',
        title: '8组精密球幕镜头'
      },
      {
        fontImg: 'icon-sfm',
        title: 'AI空间重构算法'
      },
      {
        fontImg: 'icon-3d',
        title: '自动三维数字重建'
      },
      {
        fontImg: 'icon-bianji',
        title: '制作交互式视频'
      },
      {
        fontImg: 'icon-liulan',
        title: '兼容多平台展示'
      }
    ]
  },
  app: {
    title: '4DKankan App',
    sub: ['快速编辑和分享你的互动式视频', '分享你的空间故事']
  },
  definition: {
    title: '12K高清画质 720°空间漫游',
    top: {
      dec:
          ['四维看看Pro全方位记录空间中的信息，生成实景3D数字空间。您可以随时走进生成的3D场景中自由探索，', '感受如临现场的在线空间漫游体验。12K高清分辨率，可4倍放大画面，不错过任何细节。'],
      intro: '四维看看Pro所拍摄的画面分辨率最高可达12288*6144像素'
    },
    bottom: {
      title: '细节之处，纤毫毕现',
      dec: ['4DKanKan Pro 从视觉外观到握持手感，再到机身防护，无处不凝聚匠心巧思。', '以Pro的独特性作为设计理念，以想象力的创意概念作为设计亮点。', '精湛工艺，细致耐用，细节之处，纤毫毕现。'],
      params2: [
        {
          icon: baseUrl + 'images/icon1.png',
          txt: '实时分享实训世界的所有惊喜。如今，360度图像可实现即时串流！'
        },
        {
          icon: baseUrl + 'images/icon2.png',
          txt: '使用专用智能手机应用程式，拍摄的同事检查曝光和白平衡。'
        },
        {
          icon: baseUrl + 'images/icon3.png',
          txt: '快门速度的设定范围为1/6400秒'
        },
        {
          icon: baseUrl + 'images/icon4.png',
          txt: '静态图像：（大）约1600'
        }
      ]
    }
  },
  hardware: [
    {
      title: ['汇聚一线精湛科技与工艺']
    },
    {
      title: ['海思™摄像机芯片', '高质量图像，低码率，低功耗']
    },
    {
      title: ['8组高清球幕镜头', '创新光学设计，适应复杂的环境和光线']
    },
    {
      title: ['SONY CMOS 图像传感器']
    },
    {
      title: ['4小时无间断拍摄', '超长续航，轻量便携，随时随地记录空间']
    }
  ],
  feature: {
    definition: {
      title: '图像清晰度',
      case1: {
        content: baseUrl + 'video/8k.mp4',
        back: baseUrl + 'video/4k.mp4',
        lTxt: '四维看看 Lite',
        rTxt: '四维看看 Pro',
        lMask: '4K高清',
        rMask: '12K高清图像，4倍放大'
      }
    },
    ranging: {
      title: ['测距功能', '更极致的空间还原度'],
      sub: '显示测距',
      hide: '隐藏测距'
    },
    manyou: {
      title: ['房间信息', '更极致的空间还原度'],
      left: '四维看看 Lite',
      right: '四维看看 Pro'
    },
    model: {
      title: ['空间结构', '更极致的空间还原度'],
      case2: {
        content: baseUrl + 'video/qingxi.mp4',
        back: baseUrl + 'video/moku.mp4',
        lTxt: '四维看看 Lite',
        rTxt: '四维看看 Pro'
      }
    },
    endurance: {
      title: '续航时间'
    }
  },
  technology: {
    title: '由内而外的科技之美',
    dec: '四维看看 Pro 由数百个精密元件配合运作，轻巧紧凑，便携耐用，随时为您记录3D实景空间。'
  },
  parmas: {
    name: '四维看看 Pro 详细参数'
  },
  standardGroup: {
    label: '型号',
    name: '四维看看 Pro',
    info: [{
      label: '高度：220.7mm 宽度：78.2mm 厚度：78.2mm 重量：660g',
      value: ''
    }, {
      label: '宽度',
      value: '78.2mm'
    }, {
      label: '厚度',
      value: '78.2mm'
    }, {
      label: '重量',
      value: '660g'
    }],
    params1: [{
      label: '镜头',
      value: ['类型：200°鱼眼镜头', '孔径：f/2.0', '数量：8个', '分辨率：4608*3456像素（每个）；12288*6144像素（合计）']
    }, {
      label: '传感器',
      value: ['范围：1/2.3英寸', '数量：8个']
    }, {
      label: '存储内存',
      value: ['16GB']
    }],
    params2: [{
      label: '电池',
      value: ['7.4V 4200mAh', '可通过USB快速充电']
    }, {
      label: 'WiFi',
      value: ['802.11a/b/g/n网络协议', '支持2.4/5GHz通信']
    }, {
      label: '设备接口',
      value: ['TYPE C']
    }]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/eight.js